import React from "react";
import { capabilities } from "../data/content";

export default function Capabilities() {
  return (
    <section id="capabilities" className="section-pad border-t border-rule">
      <div className="wrap">
        <header className="reveal mb-12 max-w-3xl">
          <p className="label">03 / Capabilities</p>
          <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em]">
            What I work with
          </h2>
          <p className="mt-4 text-ink-secondary">
            Grouped by engineering surface—not ranked, not scored. Breadth only
            matters when it connects into one coherent system.
          </p>
        </header>

        <div className="grid gap-px border border-rule bg-rule md:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((group) => (
            <div key={group.id} className="reveal bg-canvas-raised p-6 md:p-8">
              <h3 className="label mb-5 text-accent-strong">{group.label}</h3>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li
                    key={item}
                    className="border-b border-rule/70 pb-2 text-sm text-ink last:border-0"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
